<div class="container">
  <h1 class="text-orange text-2xl">Kontakt</h1>
  <address class="mt-4 text-gray text-normal not-italic">
    GLANZ UND GLORIA<br />
    Agentur für Kommunikation UG (hb)<br />
    Herlingsburg 6-10<br />
    22529 Hamburg<br />
    <a
      href="https://www.google.de/maps?q=Herlingsburg+6-10,+22529+Hamburg&hl=de&ll=53.585079,9.955587&spn=0.011044,0.031478&sll=53.58527,9.955587&sspn=0.011044,0.031478&hnear=Herlingsburg+6,+22529+Hamburg&t=m&z=16"
      target="blank"
      class="flex flex-row items-center gap-x-1 text-orange"
      >Google Maps
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
        />
      </svg>
    </a>
  </address>

  <p class="text-gray mt-4">
    <a href="tel:+494033425133">T +49 40 334 251 33</a><br />
    F +49 40 334 251 35
  </p>

  <p class="text-gray mt-4">
    <a
      href="&#x6d;&#x61;&#x69;&#x6c;&#x74;&#x6f;&#x3a;&#x6b;&#x6f;&#x6e;&#x74;&#x61;&#x6b;&#x74;&#x40;&#x67;&#x6c;&#x61;&#x6e;&#x7a;&#x2d;&#x75;&#x6e;&#x64;&#x2d;&#x67;&#x6c;&#x6f;&#x72;&#x69;&#x61;&#x2e;&#x65;&#x75;"
    >
      kontakt@glanz-und-gloria.eu</a
    ><br />

    <a href="https://www.glanz-und-gloria.eu">www.glanz-und-gloria.eu</a>
  </p>

  <div class="mt-16 flex flex-col md:flex-row gap-y-4 md:gap-x-4">
    <img src="/img/viola_frank.jpg" alt="Viola Frank" class="w-48 h-48" />
    <div class="mb-8">
      <h2 class="text-orange text-2xl">VIOLA FRANK</h2>
      <q class="italic text-gray"> Man muss bezaubern können, um etwas Wesentliches zu bekommen. </q>
      <p class="text-gray mt-4">
        Nach Stationen in namhaften Strategie- und Kreativ-Agenturen arbeitete Viola Frank zunächst als freie Beraterin
        für nationale und internationale Agenturen und Marken. 2010 gründete sie die Agentur Glanz und Gloria – und
        gehört damit zu den First Movern in der Social-Media- und Influencer-Marketing-Branche.
      </p>
    </div>
  </div>
</div>
